import VTextField from '../../GENIO/components/GTextField/GTextField'

export { VTextField }
export default VTextField
